export default __webpack_public_path__ + "static/media/Api.7bd57342.md";